var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileQrLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7803 0.214844H32.766L21.2216 13.5836H34.4191C41.4963 13.5836 41.383 18.7478 39.3041 21.2201L24.4406 38.6502H9.45498L25.4046 20.1802C27.069 18.2529 25.3167 15.2548 22.7757 15.2548C20.6256 15.2548 18.9695 16.1916 17.5614 17.8223L14.6272 21.2201C12.3997 23.7996 10.0135 25.2814 5.76516 25.2814C1.99669 25.2814 -0.50601 21.4551 1.96208 18.597L17.7803 0.214844Z",
    fill: "#0851FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileQrLogo);
export default __webpack_public_path__ + "static/media/mobile-qr-logo.2c2916e88d0950736c3635c2d96f971b.svg";
export { ForwardRef as ReactComponent };